var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_2204_5479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.5 7.33334C6.5 7.86378 6.71071 8.37248 7.08579 8.74756C7.46086 9.12263 7.96957 9.33334 8.5 9.33334C9.03043 9.33334 9.53914 9.12263 9.91421 8.74756C10.2893 8.37248 10.5 7.86378 10.5 7.33334C10.5 6.80291 10.2893 6.2942 9.91421 5.91913C9.53914 5.54406 9.03043 5.33334 8.5 5.33334C7.96957 5.33334 7.46086 5.54406 7.08579 5.91913C6.71071 6.2942 6.5 6.80291 6.5 7.33334Z",
    stroke: "#0071BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.2687 11.1047L9.44006 13.9334C9.19006 14.1831 8.85112 14.3234 8.49773 14.3234C8.14434 14.3234 7.80541 14.1831 7.5554 13.9334L4.72607 11.1047C3.98021 10.3588 3.47229 9.40852 3.26652 8.37396C3.06076 7.3394 3.16639 6.26706 3.57007 5.29254C3.97374 4.31801 4.65733 3.48508 5.53439 2.89905C6.41144 2.31303 7.44258 2.00024 8.4974 2.00024C9.55222 2.00024 10.5834 2.31303 11.4604 2.89905C12.3375 3.48508 13.0211 4.31801 13.4247 5.29254C13.8284 6.26706 13.934 7.3394 13.7283 8.37396C13.5225 9.40852 13.0146 10.3588 12.2687 11.1047Z",
    stroke: "#0071BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2204_5479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.4caae0ea9693065ff1895df39237a912.svg";
export { ForwardRef as ReactComponent };